import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const addPartyContact = (data,prefix, first_name, middle_name, last_name,phone_number,mobile_number,email,createuser) => {
  return axios.post(API + "parties/add-contact/"+data+"/", {
    prefix,
    first_name,
    middle_name,
    last_name,
    phone_number,
    mobile_number,
    email,
    createuser
  },{headers: authHeader(),});
};
const AddPartyContactService = {
    addPartyContact,
  };
  export default AddPartyContactService;